import { InjectionToken, Type } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MODAL_EMBEDDED_CONTAINER: InjectionToken<Type<any>> = new InjectionToken<Type<any>>('modalEmbeded');
